module.exports = __webpack_public_path__ + "fonts/OpenSans-Medium.7d5f0e32.woff";